/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export { HttpInstrumentation } from './http';
export {
  Err,
  Func,
  GetFunction,
  Http,
  HttpCallback,
  HttpCallbackOptional,
  HttpCustomAttributeFunction,
  HttpInstrumentationConfig,
  HttpRequestArgs,
  HttpRequestCustomAttributeFunction,
  HttpResponseCustomAttributeFunction,
  Https,
  IgnoreIncomingRequestFunction,
  IgnoreMatcher,
  IgnoreOutgoingRequestFunction,
  ParsedRequestOptions,
  RequestFunction,
  RequestSignature,
  StartIncomingSpanCustomAttributeFunction,
  StartOutgoingSpanCustomAttributeFunction,
} from './types';
export {
  extractHostnameAndPort,
  getAbsoluteUrl,
  getIncomingRequestAttributes,
  getIncomingRequestAttributesOnResponse,
  getIncomingRequestMetricAttributes,
  getIncomingRequestMetricAttributesOnResponse,
  getOutgoingRequestAttributes,
  getOutgoingRequestAttributesOnResponse,
  getOutgoingRequestMetricAttributes,
  getOutgoingRequestMetricAttributesOnResponse,
  getRequestInfo,
  headerCapture,
  isCompressed,
  isIgnored,
  isValidOptionsType,
  parseResponseStatus,
  satisfiesPattern,
  setAttributesFromHttpKind,
  setRequestContentLengthAttribute,
  setResponseContentLengthAttribute,
  setSpanWithError,
} from './utils';
